var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentsIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12604",
    "data-name": "Group 12604",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.767,
    height: 20,
    viewBox: "0 0 23.767 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    d: "M-531.174,261.266a7.077,7.077,0,0,1-3.176,1.188,14.379,14.379,0,0,1-4.559.007,7.687,7.687,0,0,1-2.7-.852,4.553,4.553,0,0,1-.9-.706,1.758,1.758,0,0,1-.49-1.31c0-3.046.015-6.093-.007-9.139a2.219,2.219,0,0,1,1.07-1.993,7.073,7.073,0,0,1,2.624-.977,13.916,13.916,0,0,1,3.724-.207,10.332,10.332,0,0,1,3.449.771,3.7,3.7,0,0,1,1.306.894,1.849,1.849,0,0,1,.5,1.282c-.006,1.344,0,2.688,0,4.033v.291c.438-.149.85-.31,1.273-.428a13.137,13.137,0,0,1,4.3-.422,11.593,11.593,0,0,1,3.25.6,4.219,4.219,0,0,1,1.713,1.02,1.879,1.879,0,0,1,.55,1.367c-.011.968-.013,1.938.012,2.906a2.1,2.1,0,0,1-.935,1.826,6.223,6.223,0,0,1-2.571,1.035,13.943,13.943,0,0,1-6.044-.091A5.776,5.776,0,0,1-531.174,261.266Zm-10.249-9.083c0,.341-.017.69.008,1.035a.577.577,0,0,0,.181.4,4.471,4.471,0,0,0,1.022.559,11.775,11.775,0,0,0,6.318.24,4.175,4.175,0,0,0,1.742-.732.594.594,0,0,0,.237-.349c.031-.387.011-.778.011-1.151A13.4,13.4,0,0,1-541.423,252.184Zm11.091,6.434c0,.323.018.647-.006.968a.522.522,0,0,0,.273.547,7.22,7.22,0,0,0,1.27.589,11.99,11.99,0,0,0,5.691.2,4.961,4.961,0,0,0,1.941-.727c.137-.095.315-.241.33-.379a10.722,10.722,0,0,0,.016-1.194A13.381,13.381,0,0,1-530.332,258.617Zm-11.091-.09c0,.334-.021.674.009,1.009a.651.651,0,0,0,.2.441,4.2,4.2,0,0,0,1,.54,11.762,11.762,0,0,0,6.338.233,4.141,4.141,0,0,0,1.717-.723.6.6,0,0,0,.239-.347c.031-.386.011-.776.011-1.149A13.418,13.418,0,0,1-541.423,258.527Zm0-3.1c0,.3-.017.6.008.891a.551.551,0,0,0,.168.38,4.741,4.741,0,0,0,1.043.571,11.743,11.743,0,0,0,6.337.235,4.152,4.152,0,0,0,1.717-.724.6.6,0,0,0,.238-.348c.033-.335.011-.675.011-1A13.385,13.385,0,0,1-541.423,255.43Z",
    transform: "translate(543.002 -242.736)",
    fill: "#febaba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M-504.21,169.785l-1.2-2.764,1.438-.627,1.2,2.765Z",
    transform: "translate(507.379 -166.129)",
    fill: "#febaba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    d: "M-388.773,169.151l1.2-2.765,1.438.623-1.2,2.765Z",
    transform: "translate(396.851 -166.121)",
    fill: "#febaba"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    d: "M-435.113,164.3h-1.533v-2.97h1.533Z",
    transform: "translate(442.216 -161.331)",
    fill: "#febaba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentsIncome);
export default __webpack_public_path__ + "static/media/parentsIncome.f4568b9695dae1dae554bcda3e876db8.svg";
export { ForwardRef as ReactComponent };